import { useDataSubmit } from 'Simple/Data.js'
import {
  APPS_LAUNCHERS_TYPES,
  LAUNCHER_DISPLAY_FORMATS,
} from 'Data/common-constants.js'

export function useOnLauncherResolved(props) {
  let submit = useDataSubmit({
    context: 'patient_image',
    viewPath: props.viewPath,
  })

  return async function onLauncherResolved({ launcher, response }) {
    switch (launcher.type) {
      case APPS_LAUNCHERS_TYPES.URL_HTTP:
      case APPS_LAUNCHERS_TYPES.URL_STATIC: {
        switch (launcher.displayFormat) {
          case LAUNCHER_DISPLAY_FORMATS.MODAL_FULLSCREEN: {
            await submit({
              type: 'open_apps_launcher_url_modal_fullscreen',
              launcher: {
                ...launcher,
                url: response.url,
              },
            })
            break
          }

          case LAUNCHER_DISPLAY_FORMATS.NEW_WINDOW:
          default: {
            window.open(response.url)
            break
          }
        }
        break
      }

      default: {
        break
      }
    }
  }
}
